
 import { codeTransactionData } from './country-code-istransactional-v2.js';
    let countryCodeList = document.getElementById('country-code-list')
    if (Boolean(countryCodeList)) {

        const country = CookieService.getCookie('AKCountry') || 'US'
        const countryLowerCase = country.toLowerCase()

        const countryPhoneDropdown = document.querySelector('#country-phone-dropdown')
        const inputCountryCode = countryCodeList?.querySelector('#input-country-code')
        const countryFlagEl = countryCodeList?.querySelector('#country-flag')
        const wudsDropdown = countryCodeList?.querySelector('.wuds-dropdown')
        const searchCountry = countryCodeList?.querySelector("#search-country")
        

        const dropwonActiveClassAdd = (visible) => {
            if(visible) {
                toggleClass(countryPhoneDropdown, 'd-none','d-block')
                wudsDropdown.classList.add('wuds-dropdown--active')
                inputCountryCode.value = ""
            } else {
                toggleClass(countryPhoneDropdown, 'd-block','d-none')
                wudsDropdown.classList.remove('wuds-dropdown--active')
                inputCountryCode.value = inputCountryCode.getAttribute('data-selected')
            }
        }

        if(inputCountryCode) {
            const defaultCountry = codeTransactionData.find((obj) => obj.iso === country)
            if (defaultCountry) {
                const mobileInput = document.querySelector('#input-mobile-num')
                if (mobileInput) {
                    if (defaultCountry.phoneLength) {
                        mobileInput.setAttribute('maxlength', defaultCountry.phoneLength)
                    } else {
                        mobileInput.setAttribute('maxlength', 10)
                    }
                }

            inputCountryCode.value = `${defaultCountry.code}`
            // inputCountryCode.value = `${codeTransactionData.filter((obj) => obj.iso === country)[0]['code']}`
            inputCountryCode.setAttribute('value', inputCountryCode.value)
            inputCountryCode.setAttribute('data-selected', inputCountryCode.value)
            }
            inputCountryCode.addEventListener('input', (e) => {
                let value = e.target.value;
                let lis = countryPhoneDropdown.querySelectorAll('li')
                Array.from(lis).forEach((li) => {
                if(li.innerText === ' ') {
                } else if (li.innerText.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
                    li.classList.remove('d-none')
                } else {
                    li.classList.add('d-none')
                }
                })
            })
        
            const searchCountryActiveEvent = (e) => {
                if(wudsDropdown.classList.contains('wuds-dropdown--active')) {
                dropwonActiveClassAdd(false)
                } else {
                dropwonActiveClassAdd(true)
                }
            }
        
            searchCountry.addEventListener('keydown', (e) => {
                if(e.keyCode === 13 || e.key === 'Enter') {
                searchCountryActiveEvent(e)
                }
            })
            searchCountry.addEventListener('click', searchCountryActiveEvent)
            searchCountry.addEventListener('blur', dropwonActiveClassAdd.bind({}, false))
            inputCountryCode.addEventListener('focus', dropwonActiveClassAdd.bind({},true))
            inputCountryCode.addEventListener('click', dropwonActiveClassAdd.bind({},true))
        
            inputCountryCode.addEventListener('blur',(ev) => {
                if(ev.relatedTarget !== searchCountry) {
                dropwonActiveClassAdd(false)
                }
            })
        }
        
        if(countryFlagEl) {
            countryFlagEl.setAttribute('countrycode', countryLowerCase)
            countryFlagEl.classList.remove(countryFlagEl.getAttribute('countrycode'))
            countryFlagEl.classList.add(countryLowerCase)
        }

        if(countryPhoneDropdown) {
            codeTransactionData.forEach((obj) => {
                let fragment = document.createDocumentFragment();
                let li = document.createElement('li');
                li.className = `wuds-dropdown__items b-flag-select__item `
                let countryNameEL = document.createElement('span')
                countryNameEL.className = `wuds-dropdown__item-text`
                countryNameEL.innerText = `${obj.country} (+${obj.code})`
                let icon = document.createElement('i')
                icon.className = `wu-flag ${obj.iso.toLowerCase()} wu-flagSize--S`
                li.appendChild(icon)
                li.appendChild(countryNameEL)
                fragment.appendChild(li)
                countryPhoneDropdown.appendChild(fragment)
                li.addEventListener('mousedown', (e) => {
                    inputCountryCode.value = `${obj.code}`
                    countryFlagEl.classList.remove(countryFlagEl.getAttribute('countrycode'))
                    inputCountryCode.setAttribute('value', inputCountryCode.value)
                    inputCountryCode.setAttribute('data-selected', inputCountryCode.value)
                    countryFlagEl.setAttribute('countrycode', obj.iso.toLowerCase())
                    countryFlagEl.classList.add(obj.iso.toLowerCase())

                    const mobileInput = document.querySelector('#input-mobile-num')
                    if (mobileInput) {
                        mobileInput.value = '';
                        if (obj.phoneLength) {
                            mobileInput.setAttribute('maxlength', obj.phoneLength)
                        } else {
                            mobileInput.setAttribute('maxlength', 10)
                        }
                    }

                    dropwonActiveClassAdd(false)
                })
            })
        }
    }
